'use strict';

var Classnames = require('classnames');
var LinkedStateMixin = require('react-addons-linked-state-mixin');
var React = require('react');
var ReactDOM = require('react-dom');
var ReactRouter = require('react-router');

var Link       = ReactRouter.Link;

var Constants  = require('../constants');
var Global     = require('../global');

var isNode = typeof document === 'undefined';
if (!isNode) {
    require('./sidebar.scss');
}

var DeviceImage = Global.DeviceImage;
var ResponsiveMixin = Global.ResponsiveMixin;

var MenuItem = React.createClass({
    mixins: [ ResponsiveMixin ],

    propTypes: {
        // Display name
        name: React.PropTypes.string.isRequired,

        // URL to link to
        url: React.PropTypes.string.isRequired,

        // True for current page (if top level) or current page AND parent (if child menu item)
        active: React.PropTypes.bool.isRequired,

        // True for sub-menu or child links (e.g. Project Testimonials)
        sub: React.PropTypes.bool,

        // True if there are child menuitems
        hasChildren: React.PropTypes.bool,
    },
    getDefaultProps: function() {
        return {
            sub: false,
            hasChildren: false,
        };
    },
    render: function() {
        var classes = Classnames({
            'pg-sidebar-menuitem': true,
            'pg-sidebar-menuitem-active': this.props.active,
            'pg-sidebar-menuitem-sub': this.props.sub,
        });

        // Mobile "The Company" page, identified by route having 'children' property, is just the sidebar
        // - i.e. when Project Showcase is open, clicking 'Project Showcase' again will collapse the submenu to show only the sidebar
        var url = this.props.children && this.state.viewportLayout != 'desktop'
            ? 'the-company'
            : this.props.url;

        var symbol;
        if (this.props.hasChildren) {
            if (this.props.active) {
                symbol = 'global/expansion/minus-grey1.png';
            } else {
                symbol = 'global/expansion/plus-grey1.svg';
            }
        } else {
            symbol = 'global/chevrons/chevron-right-grey1.png';
        }
        return (
            <div key={this.props.url} className={classes}>
                <div className='pg-sidebar-menuitem-label'>
                    <Link to={{
                        pathname: '/' + url,
                        state: {
                            // For desktop, don't scroll Project Showcase / Client Testimonial galleries to top
                            scroll: (this.state.viewportLayout == 'desktop' && !this.props.sub) || this.state.viewportLayout != 'desktop'
                        }
                    }}>
                        {this.props.name.toUpperCase()}
                    </Link>
                    {this.state.viewportLayout != 'desktop' ?
                        <button className='pg-sidebar-menuitem-control'>
                            <DeviceImage src={symbol} />
                        </button>
                    : null}
                </div>
                {this.props.children ?
                    <div className='pg-sidebar-menuitem-group'>
                        {this.props.children}
                    </div>
                : null}
            </div>
        );
    },
});

var Sidebar = React.createClass({
    mixins: [ ResponsiveMixin ],

    render: function() {
        return (
            <div className='pg-sidebar'>
                {this.props.payload.sidebar.map(s => {
                    if (s.name == 'dummy') {
                        return;
                    }
                    var hasChildren    = s.children.length > 0;
                    var active         = this.props.payload.page.urlkey == s.url;
                    var parentIsActive = this.props.payload.page.parent == s.id;
                    var showSubmenu    = hasChildren && (active || parentIsActive);
                    return (
                        <MenuItem key            = {s.id}
                                  name           = {s.name}
                                  url            = {s.url}
                                  active         = {active || parentIsActive}
                                  hasChildren    = {hasChildren}>
                            {showSubmenu && (this.state.viewportLayout == 'desktop' || s.url != 'office-furniture-leasing') ?  // TODO - finance calculator on mobile
                                <div>
                                    {s.children.map(c => {
                                        var childIsActive = this.props.location.substring(1) == c.url;
                                        return (
                                            <MenuItem key            = {c.id}
                                                      name           = {c.name}
                                                      url            = {c.url}
                                                      active         = {childIsActive}
                                                      sub            = {true} /> 
                                        );
                                    })}
                                </div>
                            : null}
                        </MenuItem>
                    );
                })}
            </div>
        );
    }
});

module.exports = Sidebar;



// WEBPACK FOOTER //
// ./src/pages/sidebar.jsx